module.exports = requirejs;


//////////////////
// WEBPACK FOOTER
// external "requirejs"
// module id = 19
// module chunks = 0